module.exports = __webpack_public_path__ + "img/logo-um-mf-ang.41e8e15c.png";